import React from "react";

const BaseWrapper = ({ children, className = "" }) => {
  return (
    <section
      className={`${className} sm:w-[95%] w-full sm:mx-auto sm:px-0 px-5`}
    >
      {children}
    </section>
  );
};

export default BaseWrapper;
